<template>
  <div class="technical-details-table-fi">
    <table
      v-if="attributes || displayAttributes"
      class="technical-details-table-fi__table"
    >
      <tbody>
        <tr
          v-for="(attribute, attributeIndex) in displayAttributes"
          :key="attributeIndex"
          class="technical-details-table-fi__table-row"
        >
          <td class="technical-details-table-fi__table-column--left">
            <template v-if="attribute.AttributeName">
              <span class="technical-details-table-fi__attribute-name">
                {{ attribute.AttributeName }}
                <icon-fi
                  v-if="isSpecialAttributeName(attribute)"
                  class="technical-details-table-fi__attribute-icon"
                  icon="screw"
                />
                <!-- eslint-disable vue/no-v-html -->
                <span
                  v-else-if="!technicalNamesDisabled && attribute.TechnicalName"
                  class="technical-details-table-fi__technical-name"
                  v-html="`(${attribute.TechnicalName})`"
                />
                <!-- eslint-disable vue/no-v-html -->
              </span>
            </template>
          </td>

          <td class="technical-details-table-fi__table-column--right">
            <span
              v-if="!attribute.Value"
              class="technical-details-table-fi__attribute-value--dash"
            >
              &#8212;
            </span>
            <span
              v-else-if="attribute.Value === 'relevant'"
              class="technical-details-table-fi__attribute-value--check"
            >
              <icon-fi
                class="technical-details-table-fi__attribute-value-icon"
                icon="check"
              />
            </span>
            <!-- eslint-disable vue/no-v-html -->
            <span
              v-else
              class="technical-details-table-fi__attribute-value"
              v-html="attribute.Value"
            />
            <span
              v-if="attribute.Unit"
              v-html="` ${getBlankUnit(attribute.Unit)}`"
            />
            <!-- eslint-enable vue/no-v-html -->
          </td>
        </tr>
        <tr v-if="slugLink && showDataInfo">
          <td
            colspan="2"
            class="technical-details-table-fi__table-column--right"
          >
            <div class="technical-details-table-fi__link">
              <link-fi
                :href="slugLink"
                secondary
                :size="18"
              >
                {{ $dict.get('product-List.Table.Data-Info') }}
              </link-fi>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { IconFi, LinkFi } from 'atoms';

import slugLinkMixin from '@/mixins/slugLinkMixin.vue';

export default {
  name: 'TechnicalDetailsTableFi',
  components: {
    IconFi,
    LinkFi,
  },
  mixins: [slugLinkMixin],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    attributes: {
      type: Array,
      default: null,
    },
    technicalNamesDisabled: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showDataInfo: false, // default: true XXX
    };
  },
  computed: {
    slugLink() {
      return this.getSlugLink(this.item.catalogProductData);
    },
    displayAttributes() {
      if (this.attributes) return this.attributes;

      if (this.source === 'TechincalData') {
        return this.item?.catalogProductData?.Attributes || [];
      }

      if (this.source === 'PerformanceDataAttributes') {
        return this.item?.catalogProductData?.PerformanceDataAttributes || [];
      }

      return this.attributes || this.item.catalogProductData.Attributes || [];
    },
  },
  methods: {
    isSpecialAttributeName(attribute) {
      return attribute?.TechnicalName && attribute.AttributeKey === 'SCHL_WEITE';
    },
    getBlankUnit(unit) {
      return unit.toString().replace(/[[\]]/g, '');
    },
  },
};
</script>

<style src="./technical-details-table-fi-unscoped" />

<style scoped src="./technical-details-table-fi" />
